import { h } from "vue"

export const createRawSvgRenderer = (svgContent: string) => () =>
  h("div", { innerHTML: svgContent })
